import { render, staticRenderFns } from "./finGreeting.vue?vue&type=template&id=dcf48bfe&scoped=true&"
import script from "./finGreeting.vue?vue&type=script&lang=js&"
export * from "./finGreeting.vue?vue&type=script&lang=js&"
import style0 from "./finGreeting.vue?vue&type=style&index=0&id=dcf48bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf48bfe",
  null
  
)

/* custom blocks */
import block0 from "@/translations/FinGreeting.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc665095227%2Fsrc%2Ffincraft-app%2Fsrc%2Fcomponents%2Fpages%2FmyFinHub%2FfinGreeting.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VIcon,VRow})
